import { ROLE } from './roles.js';
export const RESPONSIBILITY_FIELDS = [
    { key: 'designerId', role: ROLE.DESIGNER, charge: 'DESIGN', field: 'designerNo' },
    { key: 'plannerId', role: ROLE.PLANNER, charge: 'PLAN', field: 'plannerNo' },
    { key: 'purchasingId', role: ROLE.FABRIC, charge: 'FABRIC', field: 'fabricPurNo' },
    { key: 'productionId', role: ROLE.PRODUCTION, charge: 'PRODUCTION', field: 'productionNo' },
];
/** SAP 兼容字段保留 CAD；实际组织只有一个版师负责人。 */
export const SHEET_ASSIGNMENT_FIELDS = [
    ...RESPONSIBILITY_FIELDS,
    { key: 'patternId', role: ROLE.PATTERN, charge: 'PATTERN', field: 'patternNo' },
    { key: 'cadId', role: ROLE.PATTERN, charge: 'CAD', field: 'cadNo' },
];
export const VISIBLE_ASSIGNMENT_FIELDS = SHEET_ASSIGNMENT_FIELDS.filter(f => f.key !== 'cadId');
/** 本款版师统一负责全部技术任务；只有历史单未设版师时才回落旧 CAD。 */
export function technicalOwner(charges) {
    return charges.find(c => c.role === 'PATTERN' && c.empNo)?.empNo
        ?? charges.find(c => c.role === 'CAD' && c.empNo)?.empNo ?? null;
}
/** 指定/清空版师时同步兼容 CAD 字段；省略两者时不改历史分工。 */
export function unifyTechnicalSelection(input) {
    if (input.patternId === undefined && input.cadId === undefined)
        return input;
    const patternId = input.patternId !== undefined ? input.patternId : input.cadId;
    return { ...input, patternId, cadId: patternId };
}
/** 兼容旧 SAP 的两个担当字段，实际负责人统一为版师。 */
export const TECHNICAL_ASSIGNMENT_FIELDS = SHEET_ASSIGNMENT_FIELDS.filter(f => f.key === 'patternId' || f.key === 'cadId');
/**
 * 新任务按岗位补缺：本款有效负责人 → 品类规则 → 品牌默认。
 * 人员必须按稳定账号精确匹配已过滤的候选名单；SAP工号/姓名不猜测。
 * 技术负责人只解析一次，结果同步至 SAP 所需的两个字段。
 */
export function resolveStyleAssignment(brandCd, styleCd, categoryCd, snapshot, rules, people) {
    const ownStyle = snapshot?.brandCd === brandCd && snapshot.styleCd === styleCd ? snapshot : null;
    const ownRules = rules.filter(r => r.brandCd === brandCd && r.isActive);
    const category = categoryCd && categoryCd !== '*' ? ownRules.find(r => r.categoryCd === categoryCd) : undefined;
    const brand = ownRules.find(r => r.categoryCd === '*');
    const selection = { designerId: null, plannerId: null, purchasingId: null, productionId: null, patternId: null, cadId: null };
    const origins = {};
    const unmatchedStyleFields = [];
    for (const f of VISIBLE_ASSIGNMENT_FIELDS) {
        const code = f.key === 'patternId' ? ownStyle?.patternNo || ownStyle?.cadNo : ownStyle?.[f.field];
        const specific = code ? people.find(p => p.role === f.role && p.username === code) : undefined;
        if (specific) {
            selection[f.key] = specific.id;
            origins[f.key] = { source: 'STYLE' };
            continue;
        }
        if (code)
            unmatchedStyleFields.push(f.key);
        origins[f.key] = { source: 'UNASSIGNED' };
        for (const [rule, source] of [[category, 'CATEGORY'], [brand, 'BRAND']]) {
            const id = f.key === 'patternId' ? rule?.patternId || rule?.cadId : rule?.[f.key];
            const assigned = rule && people.find(p => p.id === id && p.role === f.role);
            if (assigned && rule) {
                selection[f.key] = assigned.id;
                origins[f.key] = { source, ruleId: rule.id, revision: rule.revision };
                break;
            }
        }
    }
    selection.cadId = selection.patternId;
    origins.cadId = { ...origins.patternId };
    const missing = RESPONSIBILITY_FIELDS.filter(f => !selection[f.key]).map(f => f.key);
    return { selection, missing, origins, unmatchedStyleFields, rule: category ?? brand ?? null };
}
export function pickResponsibilityRule(rules, categoryCd) {
    const active = rules.filter(r => r.isActive);
    return active.find(r => categoryCd && r.categoryCd === categoryCd) ?? active.find(r => r.categoryCd === '*') ?? null;
}
export function validResponsibilitySelection(selection, people) {
    selection = selection ? unifyTechnicalSelection(selection) : null;
    const result = { designerId: null, plannerId: null, purchasingId: null, productionId: null };
    const missing = [];
    for (const f of RESPONSIBILITY_FIELDS) {
        const id = selection?.[f.key];
        if (id && people.some(p => p.id === id && p.role === f.role))
            result[f.key] = id;
        else
            missing.push(f.key);
    }
    for (const f of TECHNICAL_ASSIGNMENT_FIELDS) {
        if (selection?.[f.key] === undefined)
            continue;
        const id = selection[f.key];
        result[f.key] = id && people.some(p => p.id === id && p.role === f.role) ? id : null;
    }
    return { selection: result, missing };
}
//# sourceMappingURL=responsibility.js.map